import { Button, Select } from '@/components';
import Language from '@/entities/Language';
import { useState } from 'react';
import styles from './AddLanguage.module.css';

interface AddLanguageProps {
  languages: Language[];
  languageAdded: (language: Language) => void;
}

const AddLanguage = ({
  languages = [],
  languageAdded = () => {},
}: AddLanguageProps): JSX.Element => {
  const [selectedLanguage, setSelectedLanguage] = useState<
    Language | undefined
  >(undefined);
  return (
    <div className={styles.container}>
      <Select
        options={languages}
        getOptionKey={(language) => language.code}
        getOptionLabel={(language) => `${language.name} (${language.code})`}
        onChange={setSelectedLanguage}
        placeholder="Choose a language"
      />
      <Button
        label="Add language"
        onClick={() => {
          if (selectedLanguage) {
            languageAdded(selectedLanguage);
          }
        }}
      />
    </div>
  );
};

export default AddLanguage;
